import { ENDPOINTS } from 'utils/api/callApi'

export enum LANE_ALERTS_ACTION_TYPES {
  FETCH_LANE_ALERTS_REQUEST = 'FETCH_LANE_ALERTS_REQUEST',
  FETCH_LANE_ALERTS_SUCCESS = 'FETCH_LANE_ALERTS_SUCCESS',
  FETCH_LANE_ALERTS_FAILURE = 'FETCH_LANE_ALERTS_FAILURE',
}

export const getLaneAlerts = (transfixLaneId: string, specificLaneId: string) => {
  return {
    type: '',
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.laneMetrics,
        group: 'lane_alerts',
        id: `${transfixLaneId}/${specificLaneId}`,
      },
      actionTypes: Object.keys(LANE_ALERTS_ACTION_TYPES),
    },
  }
}
